import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useUserInfoStore } from "@/store/userInfoStore";
import { ServiceType } from "@/types/referals";

export const useServiceTypeParam = () => {
  const [searchParams] = useSearchParams();

  const [serviceType] = useState<ServiceType>(() => {
    const serviceTypeParam = searchParams.get("service_type");

    if (
      serviceTypeParam === "delivery" ||
      serviceTypeParam === "taxi" ||
      serviceTypeParam === "eats"
    ) {
      return serviceTypeParam;
    }

    const storeServiceType = useUserInfoStore.getState().serviceType;
    if (storeServiceType !== null) return storeServiceType;

    return "eats";
  });

  useEffect(() => {
    useUserInfoStore.setState({ serviceType });
  }, [serviceType]);
};
